import ConvertTimeStamp from "../Utils/ConvertTimeStamp";

export function SortHistory(historyArr, ascending) {
  if (ascending == undefined) {
    ascending = true;
  }
  let arr = [];
  for (const key in historyArr) {
    //      console.log(key);
    let timestamp = ConvertTimeStamp(key);
    let timestampSort = ConvertTimeStamp(key, true);
    arr.push({
      timestampSort: timestampSort,
      timestamp: timestamp,
      dateStr: key,
      score: historyArr[key].Scores.Total,
    });
  }
  if (ascending) {
    arr = arr.sort((x, y) => {
      return x.timestampSort - y.timestampSort;
    });
  } else {
    arr = arr.sort((x, y) => {
      return y.timestampSort - x.timestampSort;
    });
  }
  return arr;
}
